module.exports = __webpack_public_path__ + "media/src/images/icons/flags/brazil-d4beb203e13641d0d0e602acfe3129e3.svg";